import mergeOperations from "@/util/shallowMerge"
import {
  useMutation
} from "@apollo/client"
import {
  useCallback, useMemo, useRef
} from "react"
import DEFAULT_OPERATIONS from "./contactUs.gql"

// eslint-disable-next-line import/no-anonymous-default-export
export const useContactPage = (props) => {
  const {
    operations 
  } = props
  const {
    contactMutation 
  } = mergeOperations(DEFAULT_OPERATIONS, operations)

  const formApiRef = useRef(null)

  const [submitForm, {
    data, error: contactError, loading: submitLoading 
  }] =
        useMutation(contactMutation, {
          fetchPolicy: "no-cache",
        })

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        name, email, comment, telephone 
      } = formState.values

      try {
        await submitForm({
          variables: {
            name,
            email,
            comment,
            telephone,
          },
        })

        if (formApiRef.current) {
          formApiRef.current.reset()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      }
    },
    [submitForm]
  )
  const errors = useMemo(
    () => new Map([["contactMutation", contactError]]),
    [contactError]
  )

  return {
    errors,
    handleSubmit,
    isBusy: submitLoading,
    formApiRef,
    response: data && data.contactUs,
  }
}
